import React from 'react';
import { Button as ReactButton } from '@a-ui/react';
import { translate, translateHTML } from '../../i18n';
import { ITranslations } from '../../i18n/config';
import Modal from '../Modal';
import { ModalProps } from '../Modal/Modal';

interface ConfirmationModalProps extends Pick<Required<ModalProps>, 'isOpen' | 'onRequestClose'> {
  title?: ITranslations;
  body: ITranslations;
  confirmLabel: ITranslations;
  cancelLabel: ITranslations;
  onConfirm: (e: React.MouseEvent<HTMLButtonElement>) => void;
  variant?: 'neutral' | 'danger';
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  title,
  body,
  isOpen,
  onRequestClose,
  onConfirm,
  confirmLabel,
  cancelLabel,
  variant,
}) => (
  <Modal isOpen={isOpen} title={title} onRequestClose={onRequestClose}>
    {translateHTML(body)}

    <div className="m-modal__footer u-margin-top">
      <ReactButton onClick={onConfirm} theme={variant}>
        {translate(`${confirmLabel}`)}
      </ReactButton>
      <ReactButton emphasis="medium" onClick={onRequestClose}>
        {translate(`${cancelLabel}`)}
      </ReactButton>
    </div>
  </Modal>
);

export default ConfirmationModal;
